import getDomainURL from 'utils/api'

export const getCockpitLink = () => {
	if (getDomainURL('').indexOf('staging') > -1) {
		return ('https://cockpit-staging2.proof-point-suite.com')
	} else if (getDomainURL('').indexOf('aciso') > -1) {
		return ('https://adminportal.aciso-suite.com')
	} else if (getDomainURL('').indexOf('proof-point') > -1) {
		return ('https://adminportal.proof-point-suite.com')
	} else {
		return ('https://cockpit-staging.proof-point-suite.com')
	}
}